import { render, staticRenderFns } from "./TratamientoDeSuspensiones.vue?vue&type=template&id=15c9ca74&scoped=true"
import script from "./TratamientoDeSuspensiones.vue?vue&type=script&lang=js"
export * from "./TratamientoDeSuspensiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9ca74",
  null
  
)

export default component.exports